import { create } from 'zustand';

export const useCardBindingStore = create<{
  isOpen: boolean;
  isBind: boolean;
  open: (isBind: boolean) => void;
  close: () => void;
}>((set) => ({
  isOpen: false,
  isBind: false,
  open: (isBind) => {
    set({ isOpen: true, isBind });
  },
  close: () => {
    set({ isOpen: false });
  },
}));
